import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTransmitFileTypeList(params) {
  return request({
    url: URL.mdm.basicData.transmitFileType,
    method: 'get',
    params
  })
}

export function saveTransmitFileType(data) {
  return request({
    url: URL.mdm.basicData.transmitFileType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delTransmitFileType(uuid) {
  return request({
    url: URL.mdm.basicData.transmitFileType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
